import React, {Component} from 'react'
import DefaultPFP from '../../../../assets/Icons/deafult_pfp.png'

class PersonalStats extends Component {

    // The picture that failed to load, so a broken link shows the default
    // instead. It's kept per URL, so a newly uploaded picture is tried again.
    state = { failedImage: null }

    progressBarColor(progress) {
        if (!progress) {
            return "#e3324c"
        } else if (progress < 100) {
            return "#2b5dfc"
        } else {
            return "#218b21"
        }
    }

    renderStatus = (status) => {
        let color
        switch(status) {
            case "Online":
                color = '#228b22'
                break
            case "Idle":
                color = 'orange'
                break
            case "Offline":
                color = '#cdcdcd'
                break
            default:
                color = '#cdcdcd'
            }
        return <svg className="status-icon-circle" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '.25em', marginBottom: '.1em' }}>
                    <ellipse cx="8" cy="8" rx="8" ry="8" fill={color} />
                </svg>
    }

    render() {
        let date = new Date(this.props.updatedAt)
        let now = new Date()
        const msBetweenDates = Math.abs(date.getTime() - now.getTime());
        const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);
        let online = "";
        // if (hoursBetweenDates < 24 && hoursBetweenDates < 1) {
        //     online = "Online"           
        //   } else if(hoursBetweenDates < 24 && hoursBetweenDates > 1) {
        //     online = "Idle"
        //   }
        if(this.props.status != ""){
            online = this.props.status
        }
          else{
                online = "Offline"
          }

         // console.log(`${this.props.name} is online: ${online}` )

        // Users created outside the New User form have no picture.
        const { image } = this.props
        const src = image && image !== this.state.failedImage ? image : DefaultPFP

        return (
            <div id="progress-stats-container">
                <img className="feed-profile-icon" src={src} alt="user profile" onError={() => this.setState({ failedImage: image })} />                         
                <p className="device-name" id="progress-stats-name">{this.props.name}</p>
                <div id="activity-status-users" className="flex-apart" >
                    <p >{online}</p>
                    {this.renderStatus(online)}
               </div>
                
            </div>
        )
    }
}

export default PersonalStats